import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRedeemCashData } from '../../services/api';
import '../../styles/output.css';
import '../../styles/index.css';
import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function RedeemCash() {
    const [redeemData, setRedeemData] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(false);
    
    useEffect(() => {
      let isMounted = true;
      document.title = "Redeem Member Rewards for Cash | MAX Credit Union";
      const getData = async () => {
        try {
          const result = await fetchRedeemCashData();
          setTimeout(() => {
            if (isMounted){
              setRedeemData(result);
            }
          },500);
          
        } catch (err) {
          if (isMounted){
            setError(err);
          }
        }
      };
      getData();

      const handleResize = () => {
        if (window.innerWidth < 600) {
          setIsCollapsed(true);
        } else {
          setIsCollapsed(false);
        }
      };

      handleResize(); // Set initial state

      window.addEventListener('resize', handleResize);
      
      return () => {
        isMounted=false;
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    if (error) return <div>Error: {error.message}</div>;
    if (!redeemData) return <div className='text-center'>Loading...</div>;

  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems} />
      <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
      <Header name="Redeem for Cash" />
      {isCollapsed && <TopMenu />}
      <div class='sb-body'>
      {redeemData?.memo_post_mode === 'NO' && redeemData?.redeem_off === 'NO' && parseFloat(redeemData?.pts_available_count.replace(/,/g, '')) >= 500 ? (

          <div className="mx-auto sm:max-w-3xl md:grid md:grid-cols-1 md:gap-4">
          <div className="bg-green-100 p-6 rounded-md mb-2 sm:mb-4">
              <p className="p-redeem text-green-900 text-lg text-center">Redeem { redeemData.pts_available_count } points for</p>
              <h2 className="h2-redeem text-green-900 text-5xl text-center tracking-tighter relative"><span className="absolute text-2xl -ml-4">$</span>{ redeemData.pts_available_worth }</h2>
    
              <div className="mt-6">
                <button 
                  onClick={() => navigate('/redeemcashresults')} 
                  className="btn-redeem mt-2 inline-block w-full btn-green-bg border border-transparent rounded-md py-2 text-sm font-bold text-white text-center hover:text-white"
                >
                    Submit
                </button> 
              </div>
    
              <p className="text-green-900 text-xs text-center mt-4">(After redemption, your points balance will be zero.)</p>
            </div>
            <div>
              <div className="mt-6">
                <button 
                  onClick={() => navigate('/redeem')} 
                  className="btn-redeem mt-2 inline-block w-full bg-blue-600 border border-transparent rounded-md py-2 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
                >
                  Back to Point Redemption Page
                </button>
              </div>
            
            </div>
          </div>

      ) : (
        <div>
          <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-1 md:gap-4">

            <div className="bg-green-100 p-6 rounded-md mb-2 sm:mb-4">
              <div>
                <div className="mt-6">
                    <div className="text-comeback" id="comeBack">Redemption Off. <br />Come back later.</div>
                </div>

              
              </div>
            </div>
          </div>

        </div>
      )}
      
      </div>
      </div>
    </div>
  );
}

export default RedeemCash;